"use client";

import {
  dlElementConstants,
  dlEventConstants,
} from "@repo/analytics/data-layer.constants";
import { dataLayer } from "@repo/analytics/data-layer-utils";
import { selectLoginStatus, useAppSelector } from "@repo/web-store";

interface CloseButtonProps {
  parentId: string;
}

export default function DisclaimerCloseButton({ parentId }: CloseButtonProps) {
  const loginStatus = useAppSelector(selectLoginStatus);
  const handleClose = () => {
    const el = document.getElementById(parentId);
    if (el) el.style.display = "none";

    const data = {
      section_title: dlElementConstants.DISCLAIMER_STRIP,
      component: dlElementConstants.DISCLAIMER_STRIP,
      event: dlEventConstants.CLICK,
      event_type: dlEventConstants.ICON_CLICK,
      element: dlElementConstants.DISCLAIMER_STRIP,
      cta_text: dlElementConstants.DISCLAIMER_STRIP,
    };

    const cleverTapObj = {
      EVENT_NAME: dlElementConstants.DISCLAIMER_STRIP,
    };

    dataLayer(loginStatus || "", data, cleverTapObj);
  };

  return (
    <button
      onClick={handleClose}
      className="icomoon before:content-['\e914'] inline-flex items-center justify-center text-[14px] w-[14px] h-[14px]
        md:before:text-[16px] md:before:w-[16px] md:before:h-[16px] text-base cursor-pointer md:w-[16px] md:h-[16px]"
    />
  );
};

